<template lang="pug">
  // ALTERADO: O "v-main" foi removido daqui
  v-app
    router-view
    vue-progress-bar

    //- 🚪 Modal de aviso de inatividade (global)
    InactivityWarningModal
</template>

<script>
import InactivityWarningModal from '@/components/InactivityWarningModal.vue'

export default {
  name: 'App',

  components: {
    InactivityWarningModal
  },

  data() {
    return {
      //
    }
  }
}
</script>

<style lang="scss">
@use "@/styles/index.scss";

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>
